import style from '../scss/head.module.scss';
import { Link, Logo, NavLink, Search, useFile, useThemeConfig, useTitle, useWindowSize } from 'topwrite';
import useConfig from '@@/use-config';
import { BsList } from '@react-icons/all-files/bs/BsList';
import { useSidebar } from '@/lib/use-sidebar';
import { useEffect } from 'react';
import Versions from '@/components/versions';

export default function Header() {

    const title = useTitle();
    const file = useFile();
    const config = useConfig();
    const themeConfig = useThemeConfig();

    const windowSize = useWindowSize();

    const { setOpen, open } = useSidebar();

    useEffect(() => {
        setOpen(false);
    }, [windowSize, file.path]);

    return <div className={style.head}>
        {windowSize == 'mobile' && <div onClick={() => setOpen(!open)} className={style.menu}>
            <BsList />
        </div>}
        <Link className={style.title} to='.'>
            <Logo />
            <span>{title}</span>
        </Link>
        {config.getValue('multiVersions') && <Versions />}
        <div className={style.navs}>
            {windowSize == 'desktop' && themeConfig.navs.map((nav, index) => {
                return <NavLink key={index} {...nav} />;
            })}
        </div>
        <div className={style.search}>
            <Search onlyCurrentPart={config.getValue('multiVersions')} />
        </div>
    </div>;
}
